import React, { useState } from "react";

import { useApi } from "../../../../api";
import I18nText from "../../../../elements/I18nText";
import ConfirmationDialog from "../../../../elements/ConfirmationDialog";
import { DeleteButton } from "../../../../elements/Button";
import useI18nSnackbar from "../../../../hooks/useI18nSnackbar";

const DeleteContainer = ({ termsId, onCancel, onDeleted }) => {
  const api = useApi();
  const { enqueueSnackbar } = useI18nSnackbar();
  const [isDeleting, setDeleting] = useState(false);

  const deleteTerms = () => {
    setDeleting(true);

    api.delete(`/v2/billing-terms/${termsId}`).then(() => {
      enqueueSnackbar("devices.settings.billing.responses.termsDeleted", {
        variant: "success"
      });
      setDeleting(false);
      onDeleted();
    });
  };

  return (
    <ConfirmationDialog
      onCancel={onCancel}
      isSubmitting={isDeleting}
      ConfirmButton={
        <DeleteButton disabled={isDeleting} onClick={deleteTerms} />
      }
    >
      <I18nText>devices.settings.billing.deleteTerms.confirmation</I18nText>
    </ConfirmationDialog>
  );
};

export default DeleteContainer;
